// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";
// // import App from "./App";
// import AppRoot from "./appRoot";
// // import * as serviceWorker from './serviceWorker';
//
// ReactDOM.render(
//   <React.StrictMode>
//     <AppRoot />
//   </React.StrictMode>,
//   document.getElementById("root"),
// );
///
//////
//

import React from "react";
import ReactDOM from "react-dom/client";

import AppRoot from "./appRoot";

const container = document.getElementById("root") as HTMLElement;

const root = ReactDOM.createRoot(container);
root.render(<AppRoot />);
